import React from 'react';
import PropTypes from 'prop-types';
import {
  AlertContainer,
  AlertContent,
  AlertLabel,
  CloseIcon,
  ExclamationIcon,
  Checkmark
} from './styled';

const Alert = ({ variant, children, label, onClear, ...props }) => {
  return (
    <AlertContainer variant={variant} {...props}>
      {onClear && <CloseIcon variant={variant} onClick={onClear} />}
      <AlertLabel>
        {variant === 'success' ? <Checkmark /> : <ExclamationIcon />}
        {label}
      </AlertLabel>
      <AlertContent>{children}</AlertContent>
    </AlertContainer>
  );
};

Alert.propTypes = {
  children: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['danger', 'warning', 'success']),
  onClear: PropTypes.func,
  className: PropTypes.string
};

Alert.defaultProps = {
  variant: 'warning',
  onClear: null,
  className: ''
};

export default Alert;
